import { render, staticRenderFns } from "./FixedTooltip.vue?vue&type=template&id=1972ba8f&scoped=true&"
import script from "./FixedTooltip.vue?vue&type=script&lang=js&"
export * from "./FixedTooltip.vue?vue&type=script&lang=js&"
import style0 from "./FixedTooltip.vue?vue&type=style&index=0&id=1972ba8f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972ba8f",
  null
  
)

export default component.exports